import { makeStyles } from '@mui/styles';

const SMCToggleSwitchStyles = makeStyles({
    wrapper: {
        marginRight: '10px',
        position: 'relative'
    },
    toggle: {
        display: 'none',
    },

    label: (props) => ({
        position: 'relative',
        display: 'block',
        width: '32px',
        height: '20px',
        borderRadius: '60px',
        outline: 'none',
        userSelect: 'none',

        cursor: props.disabled ? 'no-drop' : 'pointer',

        '&::before,&::after': {
            inset: '0',
            display: 'block',
            position: 'absolute',
            top: '1px',
            left: '1px',
            bottom: '1px',
            right: '1px',
            content: '" "',
            transition: 'all 0.1s'
        },
        '&::before': {
            inset: '0',
            borderRadius: '60px',
            background: props.checked ? props.onBackgroundColor : props.offBackgroundColor
        },

        '&::after': {
            top: '2px',
            width: '16px',
            height: '16px',
            background: '#FFFFFF',
            borderRadius: '100%',
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
            marginLeft: props.checked ? props.marginLeft : '3px'
        },
    }),
    onIcon: {
        position: 'absolute',
        top: '5px',
        left: '8px',
        zIndex: '1'
    },
    offIcon: {
        position: 'absolute', top: '4px', right: '7px', zIndex: '1'
    }

})


export default SMCToggleSwitchStyles;